/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { LandingPage } from "../../../widgets/landing-page-widget";
import { CustomMetaTags } from "../../../widgets/custom-meta-titles";
import { useTheme } from "../../../providers/theme";
import { useSMLandingPage } from "../machines/pageContent";

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const { landingPageMachine, landingPageState, landingPageSend } =
    useSMLandingPage({});

  const _renderPage = () => {
    if (landingPageState?.matches("RENDER_PAGE")) {
      console.log("Landing page state : ",landingPageState?.event?.data?.value);
      return (
        <>
          <CustomMetaTags
            {...(landingPageState?.event?.data?.value?.metaData || {})}
          />
          <LandingPage {...(landingPageState?.event?.data?.value || {})} />
        </>
      );
    }
    if (landingPageState?.matches("GET_PAGE_CONTENT")) {
      return <div>Loading...</div>;
    }
    return null;
  };
  return <>{_renderPage()}</>;
};
